<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.2476 12.5567L14.5341 8.13636C14.8015 7.86054 14.6394 7.33325 14.2871 7.33325H5.71419C5.36191 7.33325 5.19978 7.86054 5.46725 8.13636L9.75371 12.5567C9.89581 12.7032 10.1055 12.7032 10.2476 12.5567Z"/>
  </svg>
</template>
